export default function datediff(date) {
  return (new Date(date) - new Date()) / (1000 * 60 * 60 * 24);
}
